import React, { useEffect, useState } from "react";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { Alert, Snackbar } from "@mui/material";
import SellingService from "../../../services/SellingService";
import getCurrentUserId from "../../../reduxSaga/sagas/requests/currentUserId";
import UtilsFormule from "../../../utils/UtilsFormule";
import toastr from "toastr";
import SimulateRetenuByFacture from "../../../components/finance/SimulateRetenuByFacture";

const FactureGroup = ({
  listFacture,
  wallet,
}) => {
  const [selectedInvoices, setSelectedInvoices] = useState([]);
  const [accumulatedAmount, setAccumulatedAmount] = useState(0);
  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState("");
  const { SearchBar } = Search;
  const [certificatRetenu, setCertificatRetenu] = useState(false);
  const [onSimulate, setOnSimulate] = useState(false);
  const [simulateData, setSimulateData] = useState();
  const [percenteRetenu, setPercenteRetenu] = useState(0);
  const [amountRetenu, setAmountRetenu] = useState(0);
  const [accumulatedAmountMontant, setAccumulatedAmountMontant] = useState(0);
  const [fileName, setFileName] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);

  const [idsFactureSelected, setIdsFactureSelected] = useState([]);

  useEffect(() => {
    // setAccumulatedAmountMontant(accumulatedAmount);
    setIdsFactureSelected(selectedInvoices.map((invoice) => invoice.id));
  }, [selectedInvoices]);

  const columns = [
    {
      dataField: "checkbox",
      text: "Sélectionner",
      headerAlign: "center",
      align: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
      formatter: (cell, row, rowIndex, columnIndex, formatExtraData) => (
        <input type="checkbox" onChange={() => handleSelectInvoice(row)} />
      ),
    },
    {
      dataField: "reference",
      text: "Réference",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "8%" };
      },
    },
    {
      dataField: "clientName",
      text: "Le client",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "15%" };
      },
    },
    {
      dataField: "creationDate",
      text: "DC",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "12%" };
      },
      formatter: (cell, row) => (
        <span>{UtilsFormule.formatDateHours(row.creationDate)}</span>
      ),
    },
    {
      dataField: "price_tt",
      text: "Prix TTC",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
    {
      dataField: "amountToPay",
      text: "Montant à payer",
      align: "center",
      headerAlign: "center",
      headerStyle: () => {
        return { width: "10%" };
      },
    },
  ];

  // const handleSelectInvoice = (invoice) => {
  //   console.log("invoice", invoice);
  //   setSelectedInvoices((prevSelectedInvoices) => {
  //     // Check if the invoice already exists in the selected array
  //     const invoiceExists = prevSelectedInvoices.some(
  //       (selected) => selected.reference === invoice.reference
  //     );
  //     console.log("invoice.amountToPay",invoice.amountToPay)

  //     if (!invoiceExists) {
  //       console.log("in !invoiceExists")
  //       // Add the invoice and update the accumulated amount
  //       setAccumulatedAmount(
  //         (prevAmount) => +(prevAmount + invoice.amountToPay).toFixed(3) // Ensure 3 decimal places
  //       );
  //       return [...prevSelectedInvoices, invoice];
  //     } else {
  //       console.log("in else !invoiceExists")

  //       // Remove the invoice and update the accumulated amount
  //       setAccumulatedAmount(
  //         (prevAmount) => +(prevAmount - invoice.amountToPay).toFixed(3) // Ensure 3 decimal places
  //       );
  //       return prevSelectedInvoices.filter(
  //         (selected) => selected.reference !== invoice.reference
  //       );
  //     }
  //   });
  // };

  const handleSelectInvoice = (invoice) => {
    setSelectedInvoices((prevSelectedInvoices) => {
      const invoiceExists = prevSelectedInvoices.some(
        (selected) => selected.reference === invoice.reference
      );
  
      const newSelectedInvoices = invoiceExists
        ? prevSelectedInvoices.filter((selected) => selected.reference !== invoice.reference)
        : [...prevSelectedInvoices, invoice];
  
      // Calculate the new accumulated amount based on the new selection
      const newAmount = newSelectedInvoices.reduce(
        (sum, inv) => sum + inv.amountToPay,
        0
      );
      setAccumulatedAmount(+newAmount.toFixed(3));
  
      return newSelectedInvoices;
    });
  };

  const handlePayment = () => {
    // if (accumulatedAmount > walletBalance) {
    //   setInfoAlertText("Le montant total dépasse le solde du portefeuille.");
    //   setOpenInfoAlert(true);
    //   return;
    // }
    const data = {
      idWallet: wallet?.id,
      idsFacturesSale: selectedInvoices.map((invoice) => invoice.id),
    };

    console.log(selectedInvoices);
    // Assuming `payFactureByWalletAn` is the correct endpoint for the payment
    SellingService.payFactureByWalletAndGroupe(getCurrentUserId(), data)
      .then(() => {
        toastr.success("Factures payées avec succès");

        // navigate("/page-de-filtres"); // Redirect after successful payment
      })
      .catch((error) => {
        console.error(error);
        toastr.error("Echec du paiement. Veuillez réessayer.");
      });
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") return;
    setOpenInfoAlert(false);
  };
  const retenubtnPayement = () => {
    // if (!userRole.includes("COMMERCIAL")) {
    // if (factureInformation?.retenuSource === null) {
    return (
      <button
        type="submit"
        onClick={(e) => {
          setCertificatRetenu(true);
        }}
        className="btn btn-dark float-right mr-2"
      >
        Retenu
      </button>
    );
    // }
    // }
  };

  // function calculRestAfterRetenu(){
  //   setAccumulatedAmount(accumulatedAmount-amountRetenu)
  // }

  const onSimulateRetenu = () => {
    let simulData = {
      idUser: getCurrentUserId(),
      percentRetenu: percenteRetenu,
      montant: accumulatedAmountMontant,
    };
    console.log("simulData : ", simulData);
    setSimulateData(simulData);
    setOnSimulate(true);
  };
  const changePercentRetenu = (event) => {
    console.log("event", event.target.value);
    setPercenteRetenu(event.target.value);
  };

  const changeAmountRetenu = (event) => {
    console.log("event", event.target.value);
    setAmountRetenu(event.target.value);
  };
  const onFileChangeHandler = (event) => {
    if (event.target.files[0].size > 2097152) {
      // toast.info("la taille du fichier ne doit pas dépasser 2 Mo");
    } else {
      setFileName(event.target.files[0].name);
      setSelectedFile(event.target.files[0]);
    }
  };

  const saveRetenue = (e) => {
    let amountAfterRetenu=accumulatedAmount;
      if (selectedFile != null) {
        const uploadData = new FormData();
        uploadData.append("picture", selectedFile);
        SellingService.uploadFile("/uploadFile/Payement", uploadData)
          .then((response) => {
            if (response.data["success"]) {
              let retenuModel = {
                idUser: getCurrentUserId(),
                idWallet: wallet.id,
                idsFacture: idsFactureSelected,
                pourcentage: percenteRetenu,
                montant: amountRetenu,
                url: response.data["success"],
              };
              console.log("retenuModel : ", retenuModel);
  
              SellingService.saveRetenuSourceVenteWithFileV2ByFactureSelected(
                retenuModel
              )
                .then((response) => {
                  if (response.data.success) {
                    // onShowFileInOtherWizndowHandler(response.data["path"]);
                    setAmountRetenu(response.data.success.retenuAmmount);
                    setAccumulatedAmount(amountAfterRetenu-response.data.success.retenuAmmount);
                    setCertificatRetenu(false);

                    
                  } else {
                    // toast.error(
                    //   "Erreur  : il y'a un probléme au niveau de serveur"
                    // );
                  }
                })
                .catch((error) => {
                  // toast.error("Erreur  : " + error);
                });
              console.log(response, "data");
              // setMessageUpload("Votre fichier a été enregistré avec succés");
            } else {
              // toast.error("Erreur : il ya un probléme au niveau de serveur");
              // setMessageUpload("il ya un probléme au niveau de serveur");
            }
          })
          .catch(() => {
            // toast.error("Erreur : il ya un probléme de connection");
          });
      
      }else{
        let retenuModel = {
          idUser: getCurrentUserId(),
          idWallet: wallet.id,
          idsFacture: idsFactureSelected,
          pourcentage: percenteRetenu,
          montant: amountRetenu,
          url: "any",
        };
        SellingService.saveRetenuSourceVenteWithFileV2ByFactureSelected(
          retenuModel
        )
          .then((response) => {
            if (response.data.success) {
              setAmountRetenu(response.data.success.retenuAmmount);
              setAccumulatedAmount(amountAfterRetenu-response.data.success.retenuAmmount);
              setCertificatRetenu(false);


            } else {
           
            }
          })
          .catch((error) => {
          });
        }
    };
  const certificatUIResult = () => {
    if (certificatRetenu) {
      // if (factureInformation?.retenuSource === null) {
      return (
        <div class="col-12">
          <div className="card card-outline card-dark">
            <div className="card-body">
              <div className="form-group files color">
                <div class="row">
                  <div className="col-md-12">
                    <div class="row">
                      <div className="col-md-6">
                        <label>Choisir le pourcentage de retenu: </label>
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          class="form-control"
                          name="percent"
                          onChange={(e) => changePercentRetenu(e)}
                        />
                      </div>
                      <div className="col-md-6">
                        <label>Choisir le montant de retenu: </label>
                        <input
                          type="number"
                          min="0"
                          step="0.1"
                          class="form-control"
                          name="amount"
                          // value={amountRetenu}
                          onChange={(e) => changeAmountRetenu(e)}
                        />
                      </div>
                    </div>
                  </div>
                  <br />
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div className="form-group">
                      <label for="exampleInputFile">Retenu </label>
                      <div class="input-group">
                        <div class="custom-file">
                          <input
                            accept="application/pdf, .jpg, .jpeg, .png"
                            type="file"
                            className="custom-file-input"
                            id="exampleInputFile"
                            onChange={onFileChangeHandler}
                          />
                          <label
                            class="custom-file-label"
                            for="exampleInputFile"
                          >
                            {fileName}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <br />
                <div className="row">
                  <div class="col-md-9"></div>
                  <div class="col-md-1">
                    <button
                      className="btn btn-dark float-right"
                      onClick={saveRetenue}
                    >
                      <i class="fas fa-file-lines"></i> Enregistrer
                    </button>
                  </div>
                  <div className="col-md-1">
                    <button
                      className="btn btn-dark float-right"
                      data-toggle="modal"
                      data-target="#simuler-retenu"
                      onClick={onSimulateRetenu}
                    >
                      <i class="fas fa-eye"></i> Simuler
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
      // }
    }

  };
  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">Les factures</h3>
      </div>

      <div className="card-body">
        <ToolkitProvider
          keyField="factureId"
          data={listFacture}
          columns={columns}
          exportCSV
          search
        >
          {(props) => (
            <div>
              <div className="row ml-0">
                <div>
                  <SearchBar
                    {...props.searchProps}
                    className="custome-search-field"
                    style={{ color: "black" }}
                    placeholder="Chercher"
                  />
                </div>
              </div>
              <div className="row">
                <BootstrapTable
                  {...props.baseProps}
                  // pagination={paginationFactory()}
                  striped
                  hover
                  condensed
                />
              </div>
            </div>
          )}
        </ToolkitProvider>

        <div className="text-right mt-3">
          <strong>Total à payer:</strong> {accumulatedAmount} DNT
        </div>
        <div className="card-footer">
          <button
            type="submit"
            onClick={handlePayment}
            className="btn btn-dark float-right"
            disabled={accumulatedAmount === 0}
          >
            Payer
          </button>
          {retenubtnPayement()}
        </div>
      </div>

      {openInfoAlert && (
        <Snackbar
          open={openInfoAlert}
          autoHideDuration={2000}
          onClose={handleInfoClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        >
          <Alert variant="filled" onClose={handleInfoClose} severity="info">
            {infoAlertText}
          </Alert>
        </Snackbar>
      )}

      <section className="m-2">
        {wallet && certificatRetenu && certificatUIResult()}
      </section>
      {onSimulate && (
        <SimulateRetenuByFacture
          setOnSimulate={setOnSimulate}
          simulateData={simulateData}
        />
      )}
    </div>
  );
};

export default FactureGroup;
